import { getThunkAndSlice } from "@src/store/getThunkAndSlice";
import { RootState } from "../store";
import { pricingActions } from "..";
import { IGlobalInventoryRawItem } from "@src/store/pricing/queryGlobalInventorySlice";
import { getInventoryCacheEventId } from "@src/store/pricing/queryEventInventoryAllSlice";

const initialState = false;

interface RequestPayload {
	[key: string]: string | number | undefined | null | boolean;
	listingId?: number | null;
	quantity?: number;
	eventName?: string | null;
	eventDate?: string;
	eventTime?: string | null;
	eventHeadliner?: string | null;
	catId?: number;
	section?: string;
	row?: string;
	forceAttach?: boolean;
}

export const { thunk: forceAttachPdfs, slice: forceAttachPdfsSlice } = getThunkAndSlice<RequestPayload, typeof initialState>({
	initialState,
	path: (params) => (params.forceAttach ? "/api/System/ForceAttachPdfs" : "/api/System/AttachPdfs"),
	method: "postWithFilePdf",
	onAfterRequest: async (data, params, state, dispatch) => {
		const rootState = state as RootState;
		const eventId = getInventoryCacheEventId(rootState);
		const inventoryAllState = rootState.pricing.eventInventoryAll.data;
		const quantity = params.quantity ?? 0;
		let updatedCount = 0;

		const newData = inventoryAllState.map((x) => {
			if (x.Listing_ID === params.listingId && updatedCount < quantity) {
				updatedCount++;
				return { ...x, PDF_Attached: true };
			}

			return x;
		});

		dispatch(pricingActions.updateInventoryAll({ data: newData, eventId }));

		if (rootState.pricing.globalInventory.data.length) {
			const newGlobalData = (rootState.pricing.globalInventory.data as Array<IGlobalInventoryRawItem>).map((x) => {
				return x.Listing_ID === params.listingId ? { ...x, PdfsAttached: (x.PdfsAttached ?? 0) + (params.quantity ?? 1) } : x;
			});
			dispatch(pricingActions.updateGlobalInventory({ data: newGlobalData }));
		}

		return data;
	},
});
